import { Text, TextProps } from '@chakra-ui/react'

import { GuardTourStatus } from '@/graphql/generated/schemas'

import { TourStatus } from '../types/table'

export const TourStatusBadge = (
  props: TextProps & {
    status: GuardTourStatus
  }
) => {
  let badgeColor: string
  let status: TourStatus

  switch (props.status) {
    case GuardTourStatus.Completed:
      badgeColor = 'incident.resolved.100'
      status = TourStatus.COMPLETE
      break
    case GuardTourStatus.InProgress:
      badgeColor = 'incident.progress.100'
      status = TourStatus.IN_PROGRESS
      break
    case GuardTourStatus.Incomplete:
      badgeColor = 'incident.active.100'
      status = TourStatus.INCOMPLETE
      break
    default:
      status = TourStatus.UNKNOWN
      badgeColor = 'incident.active.100'
  }

  return (
    <Text
      backgroundColor={badgeColor}
      borderRadius='4px'
      color='white'
      data-testid='guardToursPage_table_status'
      fontSize='14px'
      fontWeight='bold'
      minWidth='100px'
      padding='2px 7px'
      textAlign='center'
      {...props}
    >
      {status}
    </Text>
  )
}
